<template>
  <div class="my-wallet-content ali">
    <div class="account">
      <img src="../imgs/zfb-wallet.png" alt="">
      <div class="account-btns">
        <el-button size="small" type="primary" @click="handleReflect">
          提现
        </el-button>
        <el-button size="small" type="primary" @click="showChargeDialog = true">
          充值
        </el-button>
      </div>
    </div>

    <div class="account-money">
      <div class="account-money-item">
        <div class="title">
          可用余额(元)
        </div>
        <div class="money">
          {{ isNull(data?.availableBalance) ? '--' : data?.availableBalance }}
        </div>
      </div>
    </div>
  
    <div class="account-info">
      <div class="left">
        <div class="account-info-title">
          <span v-if="term === 'server'" class="label">服务商：</span>
          <span v-if="term === 'agent'" class="label">代理商：</span>
          <span v-if="term === 'company'" class="label">企&nbsp;&nbsp;&nbsp;业：</span>
          <span class="value">{{ isNull(data?.bizName) ? '--' : data?.bizName }}</span>
        </div>
        <div class="account-info-title">
          <span class="label">账&nbsp;&nbsp;&nbsp;户：</span>
          <span class="value">{{ isNull(data?.accountNo) ? '--' : data?.accountNo }}</span>
        </div>
      </div>
      <el-popover popper-class="homepage-wallet-popover" placement="bottom-end" :width="460">
        <template #reference>
          <span class="account-info-btn">详细信息
            <svg-icon class="!w-3" icon="uiw:down" />
          </span>
        </template>
  
        <div class="flex flex-col py-2 px-2">
          <strong class="pb-4">基本信息</strong>
          <div class="finance-zl-info-box">
            <div>
              <label>支付宝账号：</label>
              <span>{{ data.bankAccount || '--' }}</span>
            </div>
            <div>
              <label>账户编号：</label>
              <span>{{ data.accountNo || '--' }}</span>
            </div>
          </div>
        </div>
      </el-popover>
    </div>

    <alipay-withdraw
      :visible="showWithdrawDialog"
      :data="data"
      :term="term"
      :pay-phone="payInfo?.payPhone"
      :loading="withdrawLoading"
      @close="showWithdrawDialog = false"
      @confirm="doWithdraw"
    />

    <alipay-charge
      :visible="showChargeDialog"
      :data="data"
      @close="showChargeDialog = false"
      @confirm="doCharge"
    />
  </div>
</template>

<script setup lang='ts'>
import AlipayWithdraw from '@core/main/src/modules/finance/wallets/alipay/AlipayWithdraw.vue';
import AlipayCharge from '@core/main/src/modules/finance/wallets/alipay/AlipayCharge.vue';
import { onConfirm, SvgIcon } from '@vue3/components';
import { inject, Ref, ref, nextTick } from 'vue';
import { IFinanceWallet } from '@core/main/types/finance';
import { isNull } from '@core/tools';
import { IAlipayWithdrawParam } from '@core/main/types/alipay';
import { doAlipayCharge, doAlipayWithdraw } from '@core/main/api';
import { ElMessage } from 'element-plus';
import { EHasPayPassword, ISecuritySettingDetail } from '@core/main/types';
import { useRouter } from 'vue-router';

const emit = defineEmits(['reload']);
const router = useRouter();

const data = inject<Ref<IFinanceWallet>>('data');
const term = inject<'server' | 'company' | 'agent'>('term');
const payInfo = inject<Ref<ISecuritySettingDetail>>('payInfo');

const chargeLoading = ref(false);
const withdrawLoading = ref(false);
const showWithdrawDialog = ref(false);
const showChargeDialog = ref(false);

function handleReflect() {
  if (payInfo.value?.hasPayPassword === EHasPayPassword.NOT_SET) {
    onConfirm({
      message: '您未设置支付密码，请前往设置！',
      okText: '去设置',
      onOk: async () => {
        router.push({ name: 'SecuritySettings' });
      },
    });
    return;
  }

  showWithdrawDialog.value = true;
}

async function doWithdraw(params: IAlipayWithdrawParam) {
  const remaining = Number(data.value.availableBalance) - Number(params.amount);

  onConfirm({
    title: '提示',
    message: `提现${params.amount}元，操作后剩余${remaining.toFixed(2)}元`,
    onOk: async () => {
      withdrawLoading.value = true;

      try {
        await doAlipayWithdraw({
          ...params,
          payPhone: payInfo.value.payPhone,
        });

        ElMessage.success('提现中，有延迟请稍等......');
        showWithdrawDialog.value = false;

        nextTick(() => {
          emit('reload');
        });
      } catch (error) {
        if ((error as Error).message) ElMessage.error((error as Error).message);
      }

      withdrawLoading.value = false;
    },
  });
}

async function doCharge(amount: number) {
  onConfirm({
    title: '提示',
    message: `即将跳转到支付宝页面，请使用账户${data.value.accountNo}完成支付。如无法跳转，请关闭浏览器拦截.`,
    onOk: async () => {
      chargeLoading.value = true;

      try {
        const payUrl = await doAlipayCharge({
          alipayAccountId: data.value.accountId,
          alipayAccountNo: data.value.accountNo,
          amount,
        });

        if (payUrl) {
          showChargeDialog.value = false;
          window.open(payUrl, '_blank');

          confirmCharge();
          return;
        }

        ElMessage.error('未获取到支付跳转链接，请稍后再试~');
      } catch (error) {
        if ((error as Error).message) ElMessage.error((error as Error).message);
      }

      chargeLoading.value = false;
    },
  });
}

function confirmCharge() {
  onConfirm({
    title: '提示',
    message: '是否已完成充值？',
    onOk: async () => {
      emit('reload');
    },
    onCancel: () => {
      emit('reload');
    },
  });
}
</script>

<style lang="scss" scoped src="../style/my-wallet.scss" />